// src/store/relationships/utils.ts
import { RelationshipEdge, RelationshipNode, RelationshipsData } from '../../services/relationships.service'

export function mergeRelationshipsData(
    atual: RelationshipsData | null,
    novo: RelationshipsData
): RelationshipsData {
    if (!atual) return novo

    const nodesPorId = new Map<string, RelationshipNode>(
        atual.nodes.map((node) => [node.id, node])
    )
    novo.nodes.forEach((node) => {
        if (!nodesPorId.has(node.id)) {
            nodesPorId.set(node.id, node)
        }
    })

    const chaveEdge = (edge: RelationshipEdge) =>
        `${edge.origin}-${edge.destination}-${edge.relationship}`

    const edgesPorChave = new Map<string, RelationshipEdge>(
        atual.edges.map((edge) => [chaveEdge(edge), edge])
    )
    novo.edges.forEach((edge) => {
        const chave = chaveEdge(edge)
        if (!edgesPorChave.has(chave)) {
            edgesPorChave.set(chave, edge)
        }
    })

    return {
        nodes: Array.from(nodesPorId.values()),
        edges: Array.from(edgesPorChave.values()),
    }
}